<div class="my-schedule-card">
  <p-card class="bucket-card">
    <div style="margin-bottom: 1em;" class="inner-card">
      <p class="field-desc">Equipment</p>
      <p-card>
        <p class="field-data"> {{ eqpString }} </p>
      </p-card>
    </div>
    <div style="margin-bottom: 1em;" class="inner-card">
      <p class="field-desc">Employees</p>
      <p-card>
        <p class="field-data"> {{ empsString }} </p>
      </p-card>
    </div>
    <div>
      <p class="field-desc">Work Orders</p>
      <div class="inner-card">
        @if ((!workOrders || workOrders.length === 0) && (!workWorkOrders || workWorkOrders.length === 0)) {
          <p-card>
            <p class="field-data">No work orders</p>
          </p-card>
        }
      </div>
      @for (wellnessWorkOrder of workOrders; track wellnessWorkOrder) {
        <div class="inner-card">
          @if (scheduledBucket && scheduledBucket.scheduledBucketWellnessWorkOrders) {
            <app-scheduled-bucket-wellness-work-order-card [showScheduled]="true"
              [bucket]="scheduledBucket" [bucketId]="scheduledBucket.id" [workOrder]="wellnessWorkOrder" [disableDrag]="true" [showMap]="true">
            </app-scheduled-bucket-wellness-work-order-card>
          }
          <!-- Big Day Subrange -->
          @if (!scheduledBucket) {
            <app-wellness-work-order-card [workOrder]="wellnessWorkOrder" [showMap]="true">
            </app-wellness-work-order-card>
          }
        </div>
      }
      @for (workWorkOrder of workWorkOrders; track workWorkOrder) {
        <div class="inner-card">
          @if (scheduledBucket && scheduledBucket.scheduledBucketWorkWorkOrders) {
            <app-scheduled-bucket-work-work-order-card [showScheduled]="true"
              [bucket]="scheduledBucket" [bucketId]="scheduledBucket.id" [workOrder]="workWorkOrder" [disableDrag]="true" [showMap]="true">
            </app-scheduled-bucket-work-work-order-card>
          }
          <!-- Big Day Subrange -->
          @if (!scheduledBucket) {
            <app-work-work-order-card [workOrder]="workWorkOrder" [showMap]="true">
            </app-work-work-order-card>
          }
        </div>
      }
    </div>
  </p-card>
</div>